<div class="app-shell" [class.app-shell--login-only]="!showAppChrome">
  @if (showAppChrome) {
    <header class="topbar-wrapper">
      <p-menubar [model]="navItems" class="topbar">
        <ng-template #start>
          <a class="brand" routerLink="/dashboard">
            <div class="brand__logo">
              <i class="fa-solid fa-water"></i>
            </div>

            <div class="brand__text">
              <span class="brand__name">{{ appName }}</span>
              <span class="brand__subtitle">Marina management</span>
            </div>
          </a>
        </ng-template>

        <ng-template #item let-item>
          <a
            class="p-menubar-item-link nav-link"
            [routerLink]="item.routerLink || null"
            [class.nav-link--active]="isExactActive(item)"
            [class.nav-link--parent-active]="isParentActive(item)"
            pRipple
          >
            @if (item.icon) {
              <i [class]="item.icon + ' p-menubar-item-icon'"></i>
            }

            <span class="p-menubar-item-label">{{ item.label }}</span>

            @if (item.items?.length) {
              <i class="fa-solid fa-chevron-down p-submenu-icon"></i>
            }
          </a>
        </ng-template>

        <ng-template #end>
          <div class="topbar-actions">
            <button pButton type="button" class="top-btn" severity="secondary" (click)="onProfileClick()">
              <i class="fa-solid fa-circle-user"></i>
              <span>Profile</span>
            </button>

            <button
              pButton
              type="button"
              class="top-btn"
              severity="secondary"
              (click)="onLogout()"
            >
              <i class="fa-solid fa-arrow-right-from-bracket"></i>
              <span>Log out</span>
            </button>
          </div>
        </ng-template>
      </p-menubar>
    </header>
  }

  <p-toast position="top-right" />

  <main class="page-shell">
    <router-outlet></router-outlet>
  </main>
</div>
